var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "searchCon" },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.CustomerCode"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("basicData.PleaseSelect"),
                                filterable: "",
                                clearable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getCustomerOption,
                              },
                              on: {
                                "visible-change": _vm.getCustomerOptionDialog,
                              },
                              model: {
                                value: _vm.queryForm.params.customerId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerId",
                              },
                            },
                            _vm._l(_vm.customerOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.username + "（" + item.id + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.creator") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                "remote-method": _vm.getUserList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: { "visible-change": _vm.getUserListDialog },
                              model: {
                                value: _vm.queryForm.params.createUser,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "createUser",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "queryForm.params.createUser",
                              },
                            },
                            _vm._l(_vm.userList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.createUserName +
                                    "(" +
                                    item.username +
                                    ")",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.operationType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.operationType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "operationType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.operationType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.add"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.edit"),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.enable"),
                                  value: 3,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.disable"),
                                  value: 4,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("operationCenter.operationTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "-",
                              "picker-options": _vm.pickerOptions,
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              "start-placeholder": _vm.$t(
                                "GlobalSetObj.startDate"
                              ),
                              "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                            },
                            model: {
                              value: _vm.queryForm.params.invoiceIssueTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "invoiceIssueTime",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.invoiceIssueTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        size: "mini",
                      },
                      on: { click: _vm.search },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", size: "mini" },
                      on: { click: _vm.onReset },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value:
                            "btn:invoiceCenter:invoiceInformationOperationLog-onExport",
                          expression:
                            "'btn:invoiceCenter:invoiceInformationOperationLog-onExport'",
                          arg: "remove",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.onExport },
                    },
                    [_vm._v(_vm._s(_vm.$t("CenterForSorting.export")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                height: _vm.tableHeightRow.height,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                  fixed: "left",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.prop,
                  attrs: {
                    align: item.align,
                    label: item.label,
                    "min-width": item.minWidth,
                    prop: item.prop,
                    "show-overflow-tooltip": item.tooltip,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "operator"
                              ? _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.createUser[scope.row.operator])
                                    ),
                                  ]),
                                ])
                              : item.prop === "requestParams"
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "pre",
                                          {
                                            staticStyle: {
                                              "max-height": "400px",
                                              overflow: "auto",
                                            },
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              "                " +
                                                _vm._s(
                                                  scope.row.requestParamsNew
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "paramsStyle" },
                                          [_vm._v(_vm._s(scope.row[item.prop]))]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : item.prop === "changeField"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.changedFields,
                                    function (list, inde) {
                                      return _c("div", { key: inde }, [
                                        _vm._v(_vm._s(list.field || "--")),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : item.prop === "oldValue"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.changedFields,
                                    function (list, inde) {
                                      return _c("div", { key: inde }, [
                                        list.field ===
                                        _vm.$t("collectionCenter.stateZT")
                                          ? _c("div", [
                                              list.oldValue == 1
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "collectionCenter.enable"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : list.oldValue == 0
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "collectionCenter.disable"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _c("div", [_vm._v("--")]),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  list.oldValue === 0
                                                    ? list.oldValue
                                                    : list.oldValue || "--"
                                                )
                                              ),
                                            ]),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : item.prop === "newValue"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.changedFields,
                                    function (list, inde) {
                                      return _c("div", { key: inde }, [
                                        list.field ===
                                        _vm.$t("collectionCenter.stateZT")
                                          ? _c("div", [
                                              list.newValue == 1
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "collectionCenter.enable"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : list.newValue == 0
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "collectionCenter.disable"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _c("div", [_vm._v("--")]),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  list.newValue === 0
                                                    ? list.newValue
                                                    : list.newValue || "--"
                                                )
                                              ),
                                            ]),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " + _vm._s(scope.row[item.prop]) + " "
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }